<div class="d-flex flex-column flex-center flex-column-fluid">
    <!--begin::Content-->
    <div class="d-flex flex-column flex-center text-center p-10">
        <!--begin::Wrapper-->
        <div class="card card-flush w-lg-650px py-5">
            <div class="card-body py-15 py-lg-20">

                <!--begin::Title-->
                <h1 class="fw-bolder fs-2hx text-gray-900 mb-4">
                    Oops!
                </h1>
                <!--end::Title-->

                <!--begin::Text-->
                <div class="fw-semibold fs-6 text-gray-500 mb-7">
                    You do not have permission to access this Hexagon section. Please discuss this with the manager.
                </div>
                <!--end::Text-->

                <!--begin::Illustration-->
                <div class="mb-3">
                    <img src="./assets/media/auth/403-error.png" class="mw-100 mh-300px theme-light-show" alt="">
                    <img src="./assets/media/auth/403-error.png" class="mw-100 mh-300px theme-dark-show" alt="">
                </div>
                <!--end::Illustration-->

            </div>
        </div>
        <!--end::Wrapper-->
    </div>
    <!--end::Content-->
</div>